import { mdiContentCopy } from '@mdi/js'
import { useState } from 'react'
import { useIntl } from 'react-intl'

import {
  HomeUIDCopy,
  HomeUIDIcon,
  HomeUIDButton,
  HomeDeviceTitle,
  StyledLabel,
  DeviceInfoPropertyContainer,
} from '../styles'
import { homeDeviceInformationMessages as messages } from '../messages'
import { commonMessages } from 'app/i18n/messages'
import { DASH_SYMBOL } from 'app/consts'

interface DeviceUIDProps {
  uid: string | undefined
  isSavant: boolean
}

function DeviceUID({ uid, isSavant = false }: DeviceUIDProps) {
  const { formatMessage } = useIntl()
  const [copied, setCopied] = useState(false)

  if (!isSavant || !uid || uid === DASH_SYMBOL) return null

  const handleClick = async () => {
    await navigator.clipboard.writeText(uid)
    setCopied(true)
    setTimeout(() => setCopied(false), 1000)
  }

  return (
    <DeviceInfoPropertyContainer>
      <StyledLabel>{formatMessage(messages.deviceUID)}</StyledLabel>
      <HomeUIDCopy>
        <HomeDeviceTitle>
          {copied ? formatMessage(commonMessages.copied) : uid}
        </HomeDeviceTitle>
        <HomeUIDButton
          onClick={handleClick}
          title={formatMessage(commonMessages.copy)}
        >
          <HomeUIDIcon path={mdiContentCopy} size={1} />
        </HomeUIDButton>
      </HomeUIDCopy>
    </DeviceInfoPropertyContainer>
  )
}

export default DeviceUID
